import script from "./NoiQuyVaHuongDanDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./NoiQuyVaHuongDanDetail.vue?vue&type=script&setup=true&lang=js"

import "./NoiQuyVaHuongDanDetail.vue?vue&type=style&index=0&id=062ef03e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-062ef03e"]])

export default __exports__